/**
 * useUserData.js
 * Hook qui charge les données utilisateur depuis Firestore
 * (name, phone, etc.) en plus des données Firebase Auth (email, uid).
 *
 * Usage :
 *   const { user, userData, loading } = useUserData();
 *   console.log(userData?.name);  // "Marie Dupont"
 */
import { useState, useEffect } from 'react';
import { auth, db } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const UseUserData = () => {
  const [user, setUser] = useState(null);           // Firebase Auth user (email, uid)
  const [userData, setUserData] = useState(null);   // Firestore user data (name, phone)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        // Charger les données Firestore
        try {
          const userDocRef = doc(db, 'users', currentUser.uid);
          const userDoc = await getDoc(userDocRef);
          
          if (userDoc.exists()) {
            setUserData(userDoc.data());
          } else {
            // Fallback si pas de doc Firestore (ne devrait pas arriver)
            setUserData({
              name: currentUser.email.split('@')[0],
              email: currentUser.email,
            });
          }
        } catch (error) {
          console.error('Erreur chargement données utilisateur:', error);
          setUserData({
            name: currentUser.email.split('@')[0],
            email: currentUser.email,
          });
        }
      } else {
        setUserData(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, userData, loading };
};

export default UseUserData;